/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aichatretry2Inputs */

const en_aichatretry2 = /** @type {(inputs: Aichatretry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const de_aichatretry2 = /** @type {(inputs: Aichatretry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch einmal versuchen`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Aichatretry2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aichatretry2 = /** @type {((inputs?: Aichatretry2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aichatretry2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aichatretry2(inputs)
	return de_aichatretry2(inputs)
});
export { aichatretry2 as "aiChatRetry" }